import React,{Component} from 'react';
import {setLocalStorageItem, getLocalStorageItem, formatNumber} from "../../../app/static_func";
import {getFavoriets, removePopup} from "../../../redux/actions";
import {connect} from "react-redux";
import * as storageKey from "../../../constants/storage-keys";
import * as routs from '../../../constants/routes';
import * as popups from '../../../constants/popup-types';
import './vehicleCard.scss';

//components
import CircularProgressBar from 'components/circularProgressBar/circularProgressBar';

//assets
import loveIcon from 'assets/icons/love_icon.svg';
import loveIconUnPressed from 'assets/icons/love_icon_blank.svg';
import lockedIcon from 'assets/icons/locked_icon.svg';
import boughtIcon from 'assets/icons/car_keys.svg';


class VehicleCard extends Component{

    constructor(props){
        super(props);
        this.state = {
            id:this.props.id,
            isLoved:false
        };

        this.handleLoveClick = this.handleLoveClick.bind(this);
        this.handleCardOnClick = this.handleCardOnClick.bind(this);
    }

    componentDidMount() {

        //check if the car is already loved
        let allFavorites = JSON.parse(getLocalStorageItem(storageKey.FAVORITES));
        if (allFavorites!==null){
            if (allFavorites.includes(this.props.licenseNum)){
                this.setState({isLoved:true});
            }
        }
    }

    handleLoveClick(e){
        e.stopPropagation();


        //get all the favorites from the local storage
        let allFavorites = JSON.parse(getLocalStorageItem(storageKey.FAVORITES));
        var id = this.props.licenseNum;

        let isLoved = false;
        let newFavorites = [];

        //check if the car is already loved
        if(allFavorites !== null) {
            if (allFavorites.includes(id)) {
                newFavorites = allFavorites.filter(function (value) {
                    return value !== id;
                });
                allFavorites = newFavorites;
            }
            else {
                allFavorites.push(id);
                isLoved = true;
            }
        }
        else {
            allFavorites =[];
            allFavorites.push(id);
            isLoved = true;
        }

        //update the local storage
        setLocalStorageItem(storageKey.FAVORITES, JSON.stringify(allFavorites));
        this.setState({isLoved:isLoved});
        this.props.getCar({licenseNumbers:allFavorites});
    }

    handleCardOnClick() {
        const {isOrdered = false,isBought = false} = this.props;

        if (!(isOrdered || isBought)) {
            //in case routing from the favorites popup
            this.props.removePopup(popups.FAVORITES);

            const isDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';

            const year = this.props.model.substring(0,4);

            const model = this.props.model.substring(5,this.props.model.length).replace(/ /g,'_');

            const title = model + '_שנת_' + year;

            if (isDesktop) {
                window.open(routs.car + '/licenseNumbers=' + this.props.licenseNum + '/' + title);
            } else {
                this.props.history.push(routs.car + '/licenseNumbers=' + this.props.licenseNum + '/' + title);
            }
        }
    }

    getCircularProgressBar(){
        const grade = this.props.grade;
        const wrapper = document.getElementById('vCard ' + this.props.id);
        let element;
        if (wrapper !== null) {
            element =  <CircularProgressBar radius={wrapper.offsetWidth * 0.13} stroke={4} progress={grade} />
        }

        return element;
    }

    render(){
        const {model,subModel,km,price,displayPhoto,isOrdered = false,isBought = false} = this.props;

        return(
            <div className='cardWrapper' id={'vCard ' + this.props.id} onClick={this.handleCardOnClick}>
                {(isOrdered || isBought) &&
                <div className='cover'>
                    <div className='message'>
                        {isOrdered &&
                        <div className='locked_icon'>
                            <img src={lockedIcon} alt='/'/>
                        </div>
                        }
                        {isBought &&
                        <img className='keys_icon' src={boughtIcon} alt='/'/>
                        }
                        <span className='locked_span'>{isOrdered ? 'רכב הוזמן' : 'רכב זה נמכר'}</span>
                    </div>
                </div>
                }
                <div className='images'>
                    <img src={displayPhoto} alt='\' className='display'/>
                    <img src={this.state.isLoved ? loveIcon : loveIconUnPressed} alt='\' className='loved'
                         onClick={(event)=>this.handleLoveClick(event)}/>
                </div>
                <div className='infoContainer'>
                    <div className='name-price'>
                        <div className='fullName'>
                            <h3 className='model'>{model}</h3>
                            <span className='subModel'>{subModel}</span>
                        </div>
                        <span className='price'>{formatNumber(price)}</span>
                    </div>
                    <div className='km-grade' id = 'gradesContainer'>
                        <span className='km'>{formatNumber(km)} ק"מ </span>
                        {this.getCircularProgressBar()}
                    </div>
                </div>
            </div>
        )
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        favorites: store.data.Favorites,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        removePopup:(payload) => dispatch(removePopup(payload)),
        getCar:(payload) => dispatch(getFavoriets(payload)),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(VehicleCard);